import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    searchMeta: null,
    searchType: null,
    filters: [],
};

const getters = {
    filters(state) {
        return state.filters;
    },
};

const mutations = {
    setSearchMeta(state, data) {
        state.searchMeta = data;
    },

    setSearchType(state, data) {
        state.searchType = data;
    },
};

const actions = {
    getSearchMeta({ commit, dispatch }) {
        let route = Laroute.route('franchise.report.voidedsales.search.meta');

        startLoading(dispatch, 'get-voided-sales-meta');

        return axios
            .get(route)
            .then(res => {
                commit('setSearchMeta', res.data);
                endLoading(dispatch, 'get-voided-sales-meta');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'get-voided-sales-meta');
                throw err;
            });
    },

    getSearchMetaIfNecessary({ commit, dispatch }) {
        if (!state.searchMeta) {
            return dispatch('getSearchMeta');
        }

        return Promise.resolve(state.searchMeta);
    },

    getSearchType({ commit, dispatch }) {
        let route = Laroute.route('franchise.report.voidedsales.search.type');

        startLoading(dispatch, 'get-voided-sales-type');

        return axios
            .get(route)
            .then(res => {
                commit('setSearchType', res.data);
                endLoading(dispatch, 'get-voided-sales-type');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'get-voided-sales-type');
                throw err;
            });
    },
};

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/voided-sales.js